import { useMessage } from "app/hooks";
import DatePickerCalendar from "components/DatePickerCalendar";
import React from "react";
import ModalCalendar from "components/ModalCalendar";
const TestPage = () => {
  const { setMessage } = useMessage();
  return (
    <div style={{ padding: "40px" }}>
      <DatePickerCalendar />
      <ModalCalendar />
    </div>
  );
};

export default TestPage;
